export const workWeekLabel = {
  workWeek: 'Work Week',
  crewType: 'CREW TYPE (Clear Selection)',
  crew: 'CREW (Clear Selection)',
  division: 'DIVISION (Clear Selection)',
  unit: 'UNIT (Clear Selection)',
  noteTxt:
    '*Note: The Crew List is a Multi Select List. Use Your SHIFT and CTRL Key to make your selections.',
  details: 'Details',
  rmowOnly: 'RM-OW Only',
  includeLaborHours: 'Include Labor Hours',
  includeScheduledHours: 'Include Scheduled Hours',
  includeScheduleCategory: 'Include Schedule Category',
  includeManpowerHeadcount: 'Include Manpower Headcount',
};

export const btnTxt = {
  seeSchedule: 'SEE SCHEDULE',
  planningReport: 'Planning Report',
};

export const weeklyScheduleMX = {
  crewDetails: 'CREW DETAILS',
  sMxSchApp: 'CHEVWORKMN',
  open: 'OPEN',
  os: 'OS',
  done: 'DONE',
  kit: 'KIT',
  fbdc: 'FBD:',
  fbd: 'FBD',
  monThru: 'MON Thru THU',
  showAll: 'Show All',
  mo: 'MO',
  tu: 'TU',
  we: 'WE',
  th: 'TH',
  fr: 'FR',
  sa: 'SA',
  su: 'SU',
  pm: 'PM',
  i: 'I',
  totalScheduled: 'Total $ Scheduled:',
  totalActual: 'Total $ Actual:',
  totalHrsSched: 'Total Hrs Sched:',
  totalEqMp: 'Total EQ MP:',
  totalHrsCharged: 'Total Hrs Charged:',
  chargeSched: 'Charge/Sched:',
  totalHrsPlanned: 'Total Hrs Planned:',
  schedPlan: 'Sched/Plan:',
  openTotal: 'Open:',
  doneTotal: 'Done:',
  total: 'Total:',
  sortBy: 'Sort By',
  workWeek: 'Work Week: ',
  sf: 'SF',
  m: 'M',
  p: 'P',
  bi: 'BI',
  c: 'C',
  e: 'E',
  oth: 'Oth',
  taskPriority: 'Task Priority',
  wonum: 'WONUM',
  taskType: 'Task Type',
  sme: 'SME',
  taskStatus: 'Task Status',
  division: 'Division',
  unit: 'Unit',
  crew: 'Crew',
  basecraft: 'Basecraft',
  location: 'Location',
  taskTitle: 'Task Title',
  d1: 'MON',
  d2: 'TUE',
  d3: 'WED',
  d4: 'THU',
  d5: 'FRI',
  d6: 'SAT',
  d7: 'SUN',
  workType: 'Work Type',
  hist: 'Hist',
  chrg: 'Chrg',
  sch: 'Sch',
  plan: 'Plan',
  mphc: 'MPHC',
  attachedDoc: 'Attached Doc',
  delayCode: 'Delay Code',
  delayDesciption: 'Delay Description',
  criticality: 'Criticality',
  miScope: 'MI Scope',
  noDataFound: 'No Data Found',
  craft: 'craft',
  showall: 'showall',
  omitInd: '*XA-BK Omit Ind',
  histFlg: 'Hist Flg',
  exportToExcel: 'Export to Excel',
  mechaniceHrsReview: 'Mechanic Hours Review',
  employeeName: 'Employee Name',
  act: 'Act',
  equiveMen: 'Equive.Men',
  routine: 'Routine',
  project: 'Project',
  records: 'Records',
  reg: 'REG',
  ot: 'OT',
  tot: 'Tot',
  longDescription: 'Long Description',
};

export const weeklyScheduleMXFilters = {
  priority: 1,
  wonum: 2,
  taskType: 3,
  taskStatus: 4,
  division: 5,
  unit: 6,
  crew: 7,
  basecraft: 8,
  location: 9,
  taskTitle: 10,
  workType: 11,
};

export const reportTitle = {
  summary: 'SUMMARY',
  vareq: 'VAREQ',
  var: 'VAR',
  vareqVariance: 'VAREQ VARIANCE',
  varVariance: 'VAR VARIANCE',
};

export const trackReports = {
  trackVSMaximoSummary: 'TRACK VS MAXIMO SUMMARY',
  trackVSMaximoEquipmentVariance: 'TRACK VS MAXIMO EQUIPMENT VARIANCE',
  trackVsMaximoLaborVariance: 'TRACK VS MAXIMO LABOR VARIANCE',
  variancesOnly: 'VARIANCES ONLY!',
  allData: 'ALL DATA',
  contractor: 'Contractor',
  workDate: 'Work Date',
  labor: 'LABOR',
  track: 'Track',
  maximo: 'Maximo',
  variance: 'Variance',
  stHours: 'ST Hours',
  otHours: 'OT Hours',
  dtHours: 'DT Hours',
  equipment: 'EQUIPMENT',
  totals: 'TOTALS',
  stotals: 'Totals',
  hours: 'Hours',
  cost: 'Cost',
  perDim: 'PER DIM',
  grandTotals: 'GRAND TOTALS',
  count: 'Count',
  resources: 'Resources',
  totalVarianceTxt:
    'Total variance must equal the non-billable WO (999999) variance',
  excludedHrsTxt: '* Excludes hours for per diem (but not costs for per diem)',
  noVariance: 'NO VARIANCES FOR SELECTED CONTRACTOR AND WORK DATE',
  varianceReportLabel:
    'Based on the file currently in the file share, the variance analysis will be performed on',
  date: 'Date',
  fileFormat:
    'Please ensure the proper format of file is uploaded in FileShare/rfm-data folder',
  runReport: 'Run Variance Reports',
};

export const application = {
  noAccess: 'You do not have access to this application',
  noPermission:
    "we're sorry, your account does not have permission to access this page.",
  menu: 'Menus',
  reports: 'Reports',
  itContactSupportTeam: 'IT Contact/Support Team',
};

export const timesheetReport = {
  exportXLS: 'Export Data XLS',
  selectAll: 'Select All',
  status: 'Status(s)',
  downloadFileTxt: 'File is downloading...',
};

export const header = {
  appTitle: 'RFMs Maximo Viewer',
  welcome: 'Welcome',
};
